// ⚠️ AUTOMATICALLY GENERATED - DO NOT CHANGE
const CHANNEL = '5a9ebad2-e830-422a-b35b-10dec38891fc';
export const MAIN = '=' + CHANNEL;
export const WORKER = '-' + CHANNEL;
